<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/thesis-reports', text: 'thesisReport_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'thesisReport_listTitle' | translate}}</h1>
        <aside>
            <button type="button" class="btn btn-outline-secondary" (click)="openSummary()">
                <i class="fi fi-rs-chart-pie"></i>
                {{'thesisReport_btnSummary' | translate}}
            </button>

            <button *ngIf="isActive && canEdit" type="button" class="btn btn-outline-primary" [routerLink]="['/thesis-reports/add'] | localize">
                <i class="fi fi-rs-plus"></i>
                {{'add' | translate}}
            </button>
        </aside>
    </header>

    <app-alert level="warning" *ngIf="isActive === false">
        <div [innerHTML]="'thesisReport_closedOutsidePeriods' | translate | safeHtml"></div>
        <ul>
            <li *ngFor="let n of activePeriods">{{n}}</li>
        </ul>
    </app-alert>

    <form>
        <div class="row">
            <div class="col-lg col-md-6 form-field">
                <app-select name="filterDoctor"
                            [placeholder]="'thesisReport_lblDoctor' | translate"
                            [options]="filters.doctor.options"
                            [multiple]="true"
                            [(ngModel)]="filters.doctor.value"
                            (selectionChange)="filter()">
                </app-select>
            </div>

            <div class="col-lg col-md-6 form-field">
                <app-select name="filterProgram"
                            [placeholder]="'thesisReport_lblProgram' | translate"
                            [options]="filters.program.options"
                            [multiple]="true"
                            [(ngModel)]="filters.program.value"
                            (selectionChange)="filter()">
                </app-select>
            </div>

            <div class="col-lg col-md-6 form-field">
                <app-select name="filterSupervisor"
                            [placeholder]="'thesisReport_lblSupervisor' | translate"
                            [options]="filters.supervisor.options"
                            [multiple]="true"
                            [(ngModel)]="filters.supervisor.value"
                            (selectionChange)="filter()">
                </app-select>
            </div>

            <div class="col-lg col-md-6 form-field">
                <input class="form-control"
                       name="filterText"
                       [placeholder]="'thesisReport_lblSearch' | translate"
                       [(ngModel)]="filters.text"
                       (input)="filter()">
            </div>
        </div>
    </form>

    <app-table [rows]="items" [columns]="columns">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>
                    <div class="hidden-sm-down">{{row.FirstName}} {{row.LastName}}</div>
                    <div class="hidden-sm-down text-sub">{{row.CertificateNumber}}</div>

                    <div class="text-top hidden-md-up">{{row.FirstName}} {{row.LastName}}</div>
                    <div class="hidden-md-up">{{row.CertificateNumber}}</div>

                    <div class="hidden-md-up text-sub mt-1">
                        <label>{{'thesisReport_lblStudyProgram' | translate}}</label>: [{{row.StudyProgramCode}}] {{row.StudyProgramName}}
                    </div>

                    <div class="hidden-md-up text-sub">
                        <label>{{'thesisReport_lblSupervisor' | translate}}</label>: {{getSupervisorDisplay(row)}}
                    </div>

                    <div class="hidden-md-up text-sub">
                        <label>{{'thesisReport_lblPrepared' | translate}}</label>: {{row.Modified | appDate}}
                    </div>

                    <div class="hidden-md-up text-sub" *ngIf="row.DvsRegNumber">
                        <label>{{'thesisReport_lblDvsRegNumber' | translate}}</label>: {{row.DvsRegNumber}} ({{row.DvsRegDate | appDate:'datetime'}})
                    </div>
                </td>
                <td class="hidden-sm-down">
                    <div>[{{row.StudyProgramCode}}] {{row.StudyProgramName}}</div>
                    <div class="text-sub">{{getSupervisorDisplay(row)}}</div>
                </td>
                <td class="hidden-sm-down">{{row.Modified | appDate}}</td>
                <td class="hidden-md-down">
                    <div *ngIf="row.DvsRegNumber">{{row.DvsRegNumber}}</div>
                    <div *ngIf="row.DvsRegDate" class="text-sub">{{row.DvsRegDate | appDate:'datetime'}}</div>
                </td>
                <td>
                    <div class="table-actions">
                        <button *ngIf="canDelete && row.Status == 'Draft'" type="button" (click)="delete(row)" class="btn btn-outline-primary btn-icon"
                                [ngbTooltip]="'delete' | translate">
                            <i class="fi fi-rs-trash"></i>
                        </button>

                        <button *ngIf="isActive && canEdit && row.Status == 'Draft'" type="button" class="btn btn-outline btn-icon" [routerLink]="['/thesis-reports', row.Id] | localize"
                                [ngbTooltip]="'edit' | translate">
                            <i class="fi fi-rs-pencil"></i>
                        </button>

                        <button *ngIf="row.Status == 'Registered'" type="button" class="btn btn-outline btn-icon" [routerLink]="['/thesis-reports', row.Id] | localize"
                                [ngbTooltip]="'open' | translate">
                            <i class="fi fi-rs-angle-right"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>
